import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateCompanyStatus } from "@/lib/api/admin-company.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateCompanyStatus() {
  const queryClient = useQueryClient()
  const { accessToken } = useAuthStore()

  return useMutation({
    mutationFn: async ({ id, status }: { id: string; status: string }) => {
      if (!accessToken) throw new Error("No access token")
      const response = await updateCompanyStatus(id, status, accessToken)
      if (response && response.success === false) throw new Error(response.message || "Failed to update status")
      return response?.data || response
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin-company-details", variables.id] })
      queryClient.invalidateQueries({ queryKey: ["admin-company-details"] })
      queryClient.invalidateQueries({ queryKey: ["admin-company-verifications"] })
    },
  })
}
